export const GET_DEFAULT_WAREHOUSE_UPDATE="GET_DEFAULT_WAREHOUSE_UPDATE"
export const GET_WAREHOUSE_DETAILS_DATA="GET_WAREHOUSE_DETAILS_DATA"